import { useTranslation } from 'react-i18next';
import { useRouter } from '@tanstack/react-router';
import { LoginForm } from '@/features/auth/ui/LoginForm';
import { LogoMark } from '@/shared/ui/Logo';

export function LoginPage() {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--color-bg)',
        padding: 'var(--space-4)',
      }}
    >
      {/* min(380px, 100%) — the fixed 380px card overflowed any viewport narrower than that
          (every phone below ~400px, i.e. most of them); 100% now resolves against <main>'s own
          padded content box, which is what actually keeps it off the screen edge. */}
      <section
        style={{
          width: 'min(380px, 100%)',
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-8) var(--space-6)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'var(--space-5)',
        }}
      >
        <header style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-3)' }}>
          <LogoMark size={48} />
          <h1
            style={{
              margin: 0,
              fontSize: 'var(--font-size-2xl)',
              fontWeight: 800,
              color: 'var(--color-text)',
            }}
          >
            {t('auth.login_title')}
          </h1>
          <p
            style={{
              margin: 'var(--space-2) 0 0',
              color: 'var(--color-text-second)',
              fontSize: 'var(--font-size-sm)',
            }}
          >
            {t('auth.login_subtitle')}
          </p>
        </header>
        <LoginForm onSuccess={() => router.navigate({ to: '/' })} />
      </section>
    </main>
  );
}
